(function() {
    let $apiSwitch = document.querySelector('#apiSwitch'),
        useMockApi = document.cookie.split(';').some((item) => item.includes('useMockApi=1')),
        handleSwitchDisplay = function (useMockApi) {
        if( $apiSwitch === null ) {
            return;
        }
            if (useMockApi === true) {
                $apiSwitch.removeAttribute('checked');
                $apiSwitch.checked = 0;
            } else {
                $apiSwitch.setAttribute('checked', true);
                $apiSwitch.checked = 1;
            }
        };

    if( $apiSwitch === null ) {
        return;
    }

    handleSwitchDisplay(useMockApi);

    $apiSwitch.addEventListener('click', () => {
        if(useMockApi === true) {
            document.cookie = 'useMockApi=0; path=/';
        }
        else {
            document.cookie = 'useMockApi=1; path=/';
        }

        handleSwitchDisplay(!useMockApi);

        setTimeout(() => {
            location.reload();
        }, 300);
    });
})();
